import Menu from '@/components/Menu';
import Slider from '@/components/Slider';
import Button from '@/components/Button';
import type { FaceFilterSettings } from '../../../types';
import { classes } from './utils';

export type ExposureMenuProps = {
  open: boolean;
  anchorTo: HTMLElement | null;
  filter: FaceFilterSettings;
  onUpdate: (filter: FaceFilterSettings) => void;
  onClose: () => void;
};

export default function ExposureMenu({
  open = true,
  anchorTo,
  filter,
  onUpdate,
  onClose,
}: ExposureMenuProps) {
  return (
    <Menu
      anchorTo={anchorTo}
      open={open}
      className={classes.menu}
      anchorOrigin={{ horizontal: 'center', vertical: 'bottom' }}
      transformOrigin={{ horizontal: 'center', vertical: 'top' }}
      onClose={onClose}>
      <div className={classes.headerWrapper}>
        <Button
          className={classes.resetButton}
          variant="ghost"
          onClick={() => onUpdate({ brightness: 50, contrast: 50 })}>
          Reset
        </Button>
      </div>
      <div className={classes.sliderWrapper}>
        <label className={classes.sliderLabel}>Brightness</label>
        <Slider
          className={classes.slider}
          valueLabelDisplay="off"
          thumbSize={20}
          max={60}
          min={40}
          value={filter.brightness}
          onChange={(brightness) => onUpdate({ ...filter, brightness })}
        />
      </div>
      <div className={classes.sliderWrapper}>
        <label className={classes.sliderLabel}>Contrast</label>
        <Slider
          className={classes.slider}
          valueLabelDisplay="off"
          thumbSize={20}
          max={60}
          min={40}
          value={filter.contrast}
          onChange={(contrast) => onUpdate({ ...filter, contrast })}
        />
      </div>
    </Menu>
  );
}
